import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

const STAFF_ALLOWED_PATTERNS = [
  /^\/admin\/master\/tahanan(\/|$)/,
  /^\/admin\/pengaturan\/pengguna(-warga|-internal)?(\/|$)/,
  /^\/admin\/layanan\/jadwal-kunjungan(\/|$)/,
  /^\/admin\/layanan\/narapidana-additions(\/|$)/,
];

export const staffAreaGuard: CanActivateChildFn = (_childRoute, state) => {
  const role = inject(AuthService).currentUser()?.role;
  if (role !== 'staff') return true;
  const path = state.url.split('?')[0];
  if (path === '/admin') return true;
  if (STAFF_ALLOWED_PATTERNS.some((p) => p.test(path))) return true;
  inject(Router).navigate(['/admin', 'master', 'tahanan']);
  return false;
};
